/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-05-04 19:30:40
 * @FilePath: \baishu_react_ui\src\components\BsyIconBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import './index.css'

class BsyIconBtn extends BsyWidget {

    constructor(props) {
        super({
            baseCls: "BsyIconBtn",
            iconName: '',
            file: props.file ? props.file : false,
            accept: props.accept ? props.accept : false,
            style: {},
            ...props
        });
        if (props.type) {
            this.options.cssName += ' ' + props.type
        }
        if (props.mode) {
            this.options.cssName += ' ' + props.mode
        }
        if (props.hoverType) {
            this.options.cssName += ' ' + props.hoverType
        }
        this.element = React.createRef();

    }

    onMouseEnter = (e) => {
        const { tip } = this.options;
        if (!tip)
            return;
        window.FX.UI.showPopover({
            position: "bottomLeft",
            anchor: window.$(e.currentTarget),
            content: window.$("<span/>").text(tip),
            type: "dark"
        })


    }
    onMouseLeave = () => {
        const { tip } = this.options;
        if (!tip)
            return;
        window.FX.UI.closePopover()
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps)
        const { text } = nextProps
        this.options.text = text
        this.setState({})
    }

    onChange = (event) => {
        this.props.onChange && this.props.onChange(event)
    }

    render() {
        // ...style,(this.props.style ? ...this.props.style : ...{})
        const { cssName, iconName, text, click, accept, file, style, } = this.options;
        return (
            <div className={cssName} onClick={click}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                title={this.options.title}
                style={{ ...style, ...(this.props.style ? this.props.style : {}) }}
                ref={this.element}
            >
                <div className="btnCont" style={{backgroundColor: this.props.bgColor}}>
                    {iconName && <i className={iconName} />}
                    {
                        text && <span style={{color: this.props.textColor}}>{text}</span>
                    }
                </div>
                {
                    file && <form className="upload-form " action="" encType="multipart/form-data" method="post">
                        <input type="file" onChange={this.onChange} name="file" id="file" className="upload-btn-input" accept={accept} />
                    </form>
                }

            </div >
        );
    }
}

export default BsyIconBtn;
